export const frontendSkills = [
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Tailwind CSS"
];

export const backendSkills = [
  "Node.js",
  "Express.js",
  "MongoDB"
];

export const programmingSkills = [
  "C",
  "C++",
  "DSA",
  "OOP",
  "Problem Solving"
];
